import { render, staticRenderFns } from "./withdrawPopup.vue?vue&type=template&id=b01d2b3e&"
import script from "./withdrawPopup.vue?vue&type=script&lang=js&"
export * from "./withdrawPopup.vue?vue&type=script&lang=js&"
import style0 from "./withdrawPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports